export default "__VITE_ASSET__9157bb33__"